<template>
  <div class="nav-content">
    <div style="margin-top: 40px">
      <Breadcrumb separator=">">
        <BreadcrumbItem @click.native="back()" class="content-item"
          >首页</BreadcrumbItem
        >
        <BreadcrumbItem @click.native="go()" class="content-item">{{
          this.title
        }}</BreadcrumbItem>
        <BreadcrumbItem v-if="state" class="content-item">{{
          this.name
        }}</BreadcrumbItem>
        <BreadcrumbItem class="content-item">详情</BreadcrumbItem>
      </Breadcrumb>
      <!-- <div
        style="
          margin-top: 17px;
          height: 62px;
          border-top: 1px solid #f3f3f3;
          border-bottom: 1px solid #f3f3f3;
          width: 1168px;
        "
      >
      </div> -->
    </div>
    <div
      style="
        font-size: 36px;
        font-weight: 600;
        line-height: 50px;
        color: #424242;
        text-align: left;
        margin-top: 20px;
      "
    >
      {{ this.total }}
    </div>
    <div v-html="txt" class="iten" style="min-height: 487px"></div>
    <div class="itn">
      <div
        style="
          margin-top: 40px;
          text-align: left;
          color: #0f0f0f;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          font-size: 18px;
        "
      >
        相关附件:
      </div>
      <div
        style="overflow: hidden; margin-bottom: 15px"
        v-for="(item, index) in list"
        :key="index"
      >
        <div style="float: left; line-height: 32px">{{ item.name }}</div>
        <div class="icons" @click="dow(item)">下载</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "detail",
  components: {},
  data() {
    return {
      txt: "",
      list: [],
      title: "",
      name: "",
      total: "",
      state: true
    };
  },
  watch: {
    //监听当前路由并更新对应数据
    $route: {
      handler: function(to, from) {
        let qwe = this.$route.query;
        this.title = qwe.title;
        if (qwe.name) {
          this.state = true;
          this.name = qwe.name;
        } else {
          this.state = false;
        }
        this.total = qwe.total;
        this.getDetail();
      },
      deep: true
    }
  },
  //保证刷新的时候（此时路由没有变化）可以实现一边基本操作
  mounted() {
    let qwe = this.$route.query;
    this.title = qwe.title;
    if (qwe.name) {
      this.state = true;
      this.name = qwe.name;
    } else {
      this.state = false;
    }
    this.total = qwe.total;
    this.getDetail();
  },
  methods: {
    //获得后台富文本编辑内容
    getDetail() {
      // let pram = localStorage.getItem("guid");
      let pram = this.$route.query.guid;
      GMS.$http
        .get(`/portal/cms/content/?guid=` + pram)
        .then(res => {
          if (res.status == 200) {
            this.txt = res.data.datas.data.text; //正文
            this.list = res.data.datas.attachements; //附件
          }
        })
        .catch(error => {
          this.$Message.error("获取数据异常");
        });
    },
    //下载附件
    dow({ guid, name = "download" }) {
      GMS.$http
        .get("/portal/cms/file?guid=" + guid, {
          responseType: "blob"
        })
        .then(res => {
          let blob = new Blob([res.data], {
            type: "multipart/form-data;charset=utf-8"
          });
          //对文件名乱码转义--【Node.js】使用iconv-lite解决中文乱码
          let iconv = require("iconv-lite");
          iconv.skipDecodeWarning = true; //忽略警告
          let downloadElement = document.createElement("a");
          let href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download = name; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉blob对象
        });
    },
    back() {
      if (this.$route.path.startsWith("/home")) {
        // 当前路由是以 /home 开头的
        this.$router.push("/home");
      } else if (this.$route.path.startsWith("/Portal")) {
        // 当前路由是以 /Portal 开头的
        this.$router.push("/Portal");
      }
    },
    go() {
      let list1 = JSON.parse(sessionStorage.getItem("navList"));
      let res = list1.find(item => item.title === this.title);
      if (this.$route.path.startsWith("/home")) {
        // 当前路由是以 /home 开头的
        if (res.childList.length === 0) {
          this.$router.push({
            path: "/home/solution",
            query: {
              id: res.id
            }
          });
        } else {
          this.$router.push({
            path: "/home/solution",
            query: {
              id: res.id,
              tagnum: res.childList[0].ordina
            }
          });
        }
      } else if (this.$route.path.startsWith("/Portal")) {
        // 当前路由是以 /Portal 开头的
        if (res.childList.length === 0) {
          this.$router.push({
            path: "/Portal/solution",
            query: {
              id: res.id
            }
          });
        } else {
          this.$router.push({
            path: "/Portal/solution",
            query: {
              id: res.id,
              tagnum: res.childList[0].ordina
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped>
.demo-breadcrumb-separator {
  padding-left: 16px;
  line-height: 42px;
  color: #7f7f7f;
  font-size: 18px;
  font-weight: 400;
}

.iten {
  margin-top: 40px;
  text-align: left;
}

.itn {
  margin-top: 63px;
  margin-bottom: 24px;
}

.icons {
  float: right;
  width: 64px;
  height: 32px;
  text-align: center;
  cursor: pointer;
  background-color: #006ac0;
  border-radius: 4px;
  line-height: 32px;
  color: #ffffff;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
}
.content-item {
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  color: #424242;
  line-height: 42px;
  font-family: PingFangSC-S0pxibold;
}
ul li {
  float: left;
  list-style: none;
  color: #424242;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 15px;
  line-height: 62px;
  margin-right: 32px;
}
.nav-content {
  width: 1200px;
  margin: 0 auto;
}
@media screen and (max-width: 1500px) {
  .nav-content {
    width: 1200px;
  }
}
@media screen and (min-width: 1500px) and (max-width: 1800px) {
  .nav-content {
    width: 1400px;
  }
}
@media screen and (min-width: 1800px) {
  .nav-content {
    width: 1600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inside/detail.vue